<template>
  <div>
    
    <div class="common-section-container gap-xl">
      <div v-for="section in sections" :key="section.title" class="common-section-container gap-sm1">
        <div class="header-text-info">
          {{ section.title }}
        </div>
        <div v-for="field in section.fields" :key="field.model">
          <div class="d-flex gap-md align-items-center" v-if="!section.inline">
            <HiloSelect
              :options="[{ id: true, name: 'Yes' }, { id: false, name: 'No' }]"
              v-model="form[field.model]"
              placeholder=" "
              :value="true"
              theme="grey"
              :customStyle="{ width: '80px', height: '48px', backgroundColor: '#f5f5f5', border: 'none' }"
            />
            <div>{{ field.label }}</div>
          </div>
          <div v-else>
            <div class="d-flex flex-column gap-md">{{ field.label }}</div>
            <input type="text" :placeholder="field.placeholder" v-model="form[field.model]">
          </div>
        </div>
      </div>
    </div>

    <div>
      <button class="primary" @click="$emit('next')">Next</button>
    </div>
  </div>
</template>

<script>
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import { PILOT_READINESS_SECTIONS } from "../../util/constants.js";
export default {
  components: { 
    HiloSelect
  },
  data() {
    return {
      form: {},
      sections: PILOT_READINESS_SECTIONS
    };
  },
  mounted() {
    this.sections.forEach(section => {
      section.fields.forEach(field => {
        if(!section.inline) this.$set(this.form, field.model, true);
      })
    })
  },
};
</script>